// Core
import Swiper from 'swiper';

// Module
import { FreeMode, Mousewheel } from 'swiper/modules';

// CSS
import 'swiper/css';
import 'swiper/css/free-mode';



export class Filter {
  constructor(filterSelector = ".filter", mapSelector = ".map") {

    const navSwiper = new Swiper('.nav-swiper', {
        modules: [FreeMode, Mousewheel],
        slidesPerView: 'auto',
        freeMode: true,
        spaceBetween: 10,
         mousewheel: true,
      });

    this.container = document.querySelector(filterSelector);
    this.mapContainer = document.querySelector(mapSelector);

    if (!this.container || !this.mapContainer) return;

    this.buttons = this.container.querySelectorAll(".btn");
    this.mapItems = this.mapContainer.querySelectorAll("div.marker");
    this.selectedRegion = '';

    this._bindEvents();
  }

  _bindEvents() {
    this.buttons.forEach((btn) => {
      if (btn.id === 'wine-region-dropdown') return;
      btn.addEventListener("click", () => this._handleClick(btn));
    });

    this._initRegionDropdown();
  }

  _initRegionDropdown() {
    const dropdown = document.getElementById('wine-region-dropdown');
    if (!dropdown) return;

    const label = dropdown.querySelector('.dropdown__label');
    const items = dropdown.querySelectorAll('.dropdown__item');

    items.forEach(item => {
      item.addEventListener('click', (e) => {
        e.stopPropagation();
        this.selectedRegion = item.dataset.value;
        label.textContent = item.textContent;
        items.forEach(i => i.classList.toggle('selected', i === item));
        dropdown.classList.remove('open');
        dropdown.setAttribute('aria-expanded', 'false');
        this._updateVisibility();
      });
    });

    dropdown.addEventListener('click', () => {
      const isOpen = dropdown.classList.toggle('open');
      dropdown.setAttribute('aria-expanded', String(isOpen));
    });

    document.addEventListener('click', (e) => {
      if (!dropdown.contains(e.target)) {
        dropdown.classList.remove('open');
        dropdown.setAttribute('aria-expanded', 'false');
      }
    });
  }

  _handleClick(clickedBtn) {
    clickedBtn.classList.toggle("inactive");
    this._updateVisibility();
  }

  _updateVisibility() {
    const inactiveCategories = [];
    this.buttons.forEach((btn) => {
      if (btn.classList.contains("inactive")) {
        inactiveCategories.push(this._getCategory(btn));
      }
    });

    this.mapItems.forEach((item) => {
      const isWinzer = Array.from(item.classList).some(c => c.startsWith('cat-winzer-'));

      if (isWinzer) {
        if (this.selectedRegion) {
          item.style.display = item.classList.contains('cat-winzer-' + this.selectedRegion) ? 'block' : 'none';
        } else {
          item.style.display = 'block';
        }
      } else {
        item.style.display = inactiveCategories.some(c => item.classList.contains('cat-' + c)) ? 'none' : 'block';
      }
    });
  }

  _getCategory(btn) {
    return Array.from(btn.classList).find(
      (c) => c !== "btn" && c !== "inactive"
    );
  }
}
